<div fxLayout="column" fxLayoutAlign="space-between stretch">
  <app-field-label-required-actions
    [control]="control"
    [indexControl]="indexControl"
    [dialogComponent]="dialogComponent"
    (updateField)="onUpdatedControl($event)"
    (deleteField)="onDeletedControl($event)"></app-field-label-required-actions>
</div>
